<template>
	<tfoot
			class="mainTableAllBack_tfoot"
			:class="{'hide':isHide}"
	>
	<tr>
		<td class="td" v-if="isIndexNumber"></td>
			<template v-for="(item, index) in headers">
			  <td
					  :key="index"
					  class="td"
					  :class="[
								item.value,
								 { 'filter-active': filterClasses[item.valueFilter] || getFilterActive(item.value),
								  'tdSticky': item.sticky
								 }]"
			  >

				  <div class="valueTd__text" v-if="item.isCheckboxTotal">n: <span class="total">{{ selected.length }}</span></div>

				  <div v-if="item.totalMod" :class="['valueTd', item.align]">
					  <div
						  :class="['valueTd__text', {'nowrap': item.nowrap}]"
		          v-html="getTotalMod({item, value: item.value} )"
					  ></div>
				  </div>

				  <div v-else :class="['valueTd', item.align]">
					  <tool-tip
							  v-if="getToolTip({ item, value: item.value })"
							  :text="helperTotal({ item, flag:'toolTip' })"
							  content-class="top"
							  :position="{ top: 'top' }"
					  >
						  <span
								  :class="[
						      'valueTd__text',
						      {
						        'nowrap': item.nowrap,
						        'valueTd__text--green': item.fullTotal
						      }
						    ]"
								  v-html="helperTotal({ item, flag:'display' })"
						  ></span>
					  </tool-tip>

					  <span
							  v-else
							  :class="[
							    'valueTd__text',
							    {
							      'nowrap': item.nowrap,
							      'valueTd__text--green': item.fullTotal
							    }
							  ]"
							  v-html="helperTotal({ item, flag:'display' })"
					  ></span>
				  </div>

			  </td>
			</template>
	</tr>
	</tfoot>
</template>

<script>

// components
import ToolTip from "@/shared/ToolTip/ToolTip";
// constants
import { FILTER_KEYS, PAGE } from "@/constants/constants";
import { filterActive } from "@/helper/getFilterClassesActive";
// helpers
import { getTotalToolTip } from "@/helper/getTotalToolTip";
import { getTotalDisplay } from "@/helper/getTotalDisplay";
import { cut } from "@/helper/getCut";

export default {
	name: "Tfoot",
	components: {
		ToolTip
	},
	props: {
		flag: String,
		isHide: Boolean,
		isIndexNumber: Boolean,
		selected: Array,
		headers: Array,
		totals: Object,
		filterClasses: Object,
	},
	methods: {
		helperTotal({ item, flag }) {
			const {
				value,
				dollar,
				miles,
				fullTotal
			} = item;

			const totalValue = this.totals[value];

			if (
				(flag === "display" && totalValue) ||
					(flag === "display" && totalValue === 0)
			) {
				if (fullTotal) {
					const formattedValue = getTotalToolTip({
						totalValue,
						dollar,
						miles
					});

					return formattedValue.replace(
						"Σ:",
						'<span class="total-prefix">Σ:</span>'
					);
				}

				return getTotalDisplay({
					totalValue: cut(totalValue),
					dollar,
					miles
				});
			}

			if (
				(flag === "toolTip" && totalValue) ||
					(flag === "toolTip" && totalValue === 0)
			) {
				return getTotalToolTip({
					totalValue,
					dollar,
					miles
				});
			}
		},
		getFilterActive(filterKey) {
			return filterActive({ filterKey, filterClasses: this.filterClasses });
		},
		getTotalMod({ item, value }) {
			const { footer } = item;
			if (this.flag === PAGE.TRIP_LIST && footer && value === FILTER_KEYS.TRIP_ID) {
				return `<div>Trips:  <span class="total">${ cut(this.totals.trip_id) }</span></div>
								<div>Loads:  <span class="total">${ cut(this.totals.load_id) }</span></div>`;
			}

			if (this.flag === PAGE.INVOICE && footer && value === FILTER_KEYS.INVOICE_ID) {
				return `<div>Total:  <span class="total">${ cut(this.totals.total) }</span></div>`;
			}
		},

		getToolTip(args) {
			const { value } = args;
			return this.totals[value] >= 1000;
		},
	}
};
</script>

<style lang="scss">
.mainTableAllBack_tfoot {
	&.hide {
		display: none;
	}

	.total-prefix {
		color: var(--card-color);
		font-weight: 400;
	}
}
</style>
<style scoped lang="scss">
.mainTableAllBack_tfoot .tdSticky {
	position: sticky;
	right: 0;
	background: #2B2B37 !important;
}

.valueTd__text {
	&--green {
		color: #4caf50;
	}
}
</style>
